<template>
  <div class="d-flex flex-column">
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-row class="mt-1">
        <v-col cols="12" sm="12" offset-sm="0" md="10" offset-md="1">
          <b-card
            header="Primary"
            header-bg-variant="secondary"
            header-text-variant="white"
            v-if="requestChangeRoute"
          >
            <template #header>
              <h6 class="mb-0">{{ $t("Change Route") }}</h6>
            </template>
            <b-card-text class="py-3 px-3">
              <v-row>
                <v-col cols="12" sm="12" md="6">
                  <h6 class="my-2">
                    {{ $t("route") }}
                    <span class="required ml-2">*</span> :
                  </h6>
                  <v-autocomplete
                    v-model="requestChangeRoute.newRouteId"
                    :items="selectableroutes"
                    item-text="name"
                    item-value="id"
                    filled
                    required
                    :rules="requiredRules"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <h6 class="my-2">
                    {{ $t("Set New Visit Day") }}
                    <span class="required ml-2">*</span> :
                  </h6>
                  <v-autocomplete
                    v-model="requestChangeRoute.visitdays"
                    :items="weekdays"
                    item-text="label"
                    item-value="value"
                    filled
                    multiple
                    required
                    :rules="requiredRulesArray"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <h6 class="my-2">
                    {{ $t("Set Week") }}
                    <span class="required ml-2">*</span> :
                  </h6>
                  <v-autocomplete
                    v-model="requestChangeRoute.settedWeeks"
                    :items="weeks"
                    filled
                    multiple
                    required
                    :rules="requiredRulesArray"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <h6 class="my-2">
                    {{ $t("Set Periods") }}
                    <span class="required ml-2">*</span> :
                  </h6>
                  <v-autocomplete
                    v-model="requestChangeRoute.settedPeriods"
                    :items="periods"
                    filled
                    multiple
                    required
                    :rules="requiredRulesArray"
                  ></v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" offset-sm="0" md="10" offset-md="1">
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" offset-sm="0" md="10" offset-md="1">
                  <h6 class="my-2">
                    {{ $t("Please enter reason") }}
                    <span class="required ml-2">*</span> :
                  </h6>
                  <v-textarea
                    v-model="requestChangeRoute.gpvComments"
                    required
                    :rules="requiredRules"
                  ></v-textarea>
                </v-col>
              </v-row>
            </b-card-text>
            <template #footer>
              <v-row>
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                  class="d-flex justify-content-center"
                >
                  <v-btn
                    color="success"
                    dark
                    class="mx-1 my-2"
                    :loading="isSaving"
                    @click="onSaveClick(requestChangeRoute)"
                  >
                    {{ $t("save") }}
                  </v-btn>
                </v-col>
              </v-row>
            </template>
          </b-card>

          <b-alert v-if="!requestChangeRoute" show variant="info">
            <b-icon
              icon="arrow-counterclockwise"
              animation="spin-reverse"
            ></b-icon>
            cargando datos...
          </b-alert>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import ApiService from "@/services/apiService";
import { mapGetters } from "vuex";
import moment from "moment";
import _ from "lodash";
import { logInfo, logError } from "@/utils";

export default {
  name: "changeRoute",
  props: ["id", "worksessionPosId"],
  components: {},
  computed: {
    ...mapGetters("auth", ["user"]),
    ...mapGetters("myroute", [
      "currentPosData",
      "currentWorksessionData",
      "currentRequestVisitDays",
      "currentVisitDays",
    ]),
  },

  data: function() {
    return {
      valid: true,
      requiredRules: [(v) => !!v || "Required"],
      requiredRulesArray: [(v) => (!!v && v.length > 0) || "Required"],
      isSaving: false,
      weekCount: 4,
      periods: [],
      weekdays: [],
      weeks: [1, 2, 3, 4],
      selectableroutes: [],
      requestChangeRoute: null,
    };
  },
  methods: {
    async onSaveClick(requestChangeRoute) {
      if (this.$refs.form.validate()) {
        let body = requestChangeRoute;
        if (!body.date) {
          body.date = new Date().toISOString().slice(0, 10);
        }
        this.isSaving = true;
        if (body.id) {
          await ApiService.put(
            `worksession/saverequestchangeroute/${body.id}`,
            body
          );
        } else {
          await ApiService.post(`worksession/saverequestchangeroute`, body);
        }
        this.isSaving = false;
        logInfo("Éxito");
        this.init();
      }
    },
    createSelectedModel(requestedChangeRoute, currentRouteData) {
      let model = {
        id: _.get(requestedChangeRoute, "id"),
        userId: _.get(requestedChangeRoute, "userId"),
        routeId: _.get(requestedChangeRoute, "routeId"),
        posId: _.get(requestedChangeRoute, "posId"),
        newRouteId: _.get(requestedChangeRoute, "newRouteId"),
        gpvComments: _.get(requestedChangeRoute, "gpvComments"),
        date: _.get(requestedChangeRoute, "date"),
        visitdays: _.get(requestedChangeRoute, "visitdays"),
        settedWeeks: _.get(requestedChangeRoute, "settedWeeks"),
        settedPeriods: _.get(requestedChangeRoute, "settedPeriods"),
      };
      if (!requestedChangeRoute) {
        model.visitdays = _.get(currentRouteData, "visitdays");
        model.settedWeeks = _.get(currentRouteData, "settedWeeks");
        model.settedPeriods = _.get(currentRouteData, "settedPeriods");
      }
      let periods = [];
      if (model.settedPeriods) {
        let settedPeriodsValue = Object.values(model.settedPeriods);
        for (const periodItem of this.periods) {
          if (settedPeriodsValue[periodItem - 1] === true) {
            periods.push(periodItem);
          }
        }
      }
      model.settedPeriods = periods;
      if (!model.userId) model.userId = this.user.id;
      if (!model.routeId) model.routeId = this.currentWorksessionData.routeId;
      if (!model.posId) model.posId = this.currentWorksessionData.posId;
      return model;
    },
    async init() {
      let { weekdays, weekCount, periodsCount } = await ApiService.post(
        `worksession/getbasedata?isFlag=weekdays`
      );
      this.weekdays = weekdays;
      this.weekCount = weekCount;
      this.weeks = [];
      for (let i = 1; i <= weekCount; i++) {
        this.weeks.push(i);
      }
      this.periods = [];
      for (let i = 1; i <= periodsCount; i++) {
        this.periods.push(i);
      }
      await this.$store.dispatch("myroute/getWorksessionPos", {
        worksessionPosId: this.worksessionPosId,
      });
      const { routeId, posId } = this.currentWorksessionData;
      let { routes } = await ApiService.post(
        `worksession/getbasedata?isFlag=selectableroutes&exceptionId=${routeId}`
      );
      this.selectableroutes = routes;
      let { requestedChangeRoute, currentRouteData } = await ApiService.get(
        `worksession/getchangeroute/${this.user.id}/${routeId}/${posId}`
      );
      this.requestChangeRoute = this.createSelectedModel(
        requestedChangeRoute,
        currentRouteData
      );
    },
  },

  async mounted() {
    await this.init();
  },
};
</script>

<style></style>
